import { useUser } from '../contexts/UserContext'
import { permissionType } from '../utils/constants'

export const useRTOSuitePermissions = () => {
  const { canAccess } = useUser()

  const canViewRTOSuite = canAccess(permissionType.VIEW_RTO_SUITE, 0)
  const canEditRTOSuite = canAccess(permissionType.EDIT_RTO_SUITE, 0)
  const canViewRTOScoring = canAccess(permissionType.RTO_SCORING_VIEW, 0)
  const canSetupRTOScoring = canAccess(permissionType.RTO_SCORING_SETUP, 0)
  const canViewCODToPrepaid = canAccess(permissionType.COD_TO_PREPAID, 0)

  return {
    canViewRTOSuite,
    canEditRTOSuite,
    canViewCODToPrepaid,
    canViewRTOScoring,
    canSetupRTOScoring
  }
}
